"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePopoverRect = usePopoverRect;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _tools = require("../../utils/tools");
function usePopoverRect(open, ref, anchorRef) {
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var computePosition = (0, _tools.debounce)(function () {
    var _ref$current, _anchorRef$current, _rect$height, _anchorRect$bottom;
    var rect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
    var anchorRect = (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.getBoundingClientRect();
    var rectH = (_rect$height = rect === null || rect === void 0 ? void 0 : rect.height) !== null && _rect$height !== void 0 ? _rect$height : 0;
    var btnRectB = (_anchorRect$bottom = anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.bottom) !== null && _anchorRect$bottom !== void 0 ? _anchorRect$bottom : 0;
    if (rectH + btnRectB > document.documentElement.clientHeight) {
      setPosition({
        left: anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.left,
        top: anchorRect.top - rect.height
      });
    } else {
      setPosition({
        left: anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.left,
        top: anchorRect === null || anchorRect === void 0 ? void 0 : anchorRect.bottom
      });
    }
  }, 100);
  (0, _react.useLayoutEffect)(function () {
    if (!open) {
      setPosition({});
      return;
    }
    computePosition();
    window.addEventListener('resize', computePosition);
    return function () {
      window.removeEventListener('resize', computePosition);
    };
  }, [open]);
  return position;
}